@if (seedAnswers.length > 0) {
    @for (seedAnswer of seedAnswers; track seedAnswer; let last = $last; let index = $index) {
        <div [ngClass]="{ 'mb-3': !last }">
            <h4>{{ seedAnswer.question }}</h4>
            <adapt-see-more [maxHeight]="350"
                            gradient>
                <div [froalaView]="seedAnswer.answer"
                     [attr.data-test]="'answerTo-' + seedType + '-' + index"></div>
            </adapt-see-more>
        </div>
    }
} @else {
    <p>No answers have been given.</p>
}
